import AppSidebar from "@/modules/app/components/sidebar"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import Body from "./body"
import Header from "./header"
import useSidebarVisibility from "@/hooks/use-sidebar-visibility"
import { useAuth } from "@/modules/auth/store"
import { Navigate } from "react-router-dom"

export default function Main() {
  const { isVisible } = useSidebarVisibility()
  const { user } = useAuth()

  if (!user.wasOnboarded) {
    return <Navigate to="/onboarding" replace />
  }
  return (
    <SidebarProvider defaultOpen={false}>
      {isVisible && <AppSidebar />}
      <SidebarInset>
        <Header />
        <main className="grid h-full w-full">
          <Body />
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}
